<template lang="html">
    <nav id="navigation" :class="{ absolute: $store.state.mobNavFix }">
        <router-link :to="{ name: 'playerProfile' }">
            <svg
                width="37px"
                height="21px"
                viewBox="0 0 37 21"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
            >
                <defs></defs>
                <g
                    id="Symbols"
                    stroke="none"
                    stroke-width="1"
                    fill="none"
                    fill-rule="evenodd"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                >
                    <g
                        id="Bottom-Nav---Lessons"
                        transform="translate(-22.000000, -15.000000)"
                        stroke="#267962"
                    >
                        <g id="Bottom-Nav">
                            <g
                                id="profile-mid-dark-green"
                                transform="translate(23.000000, 16.000000)"
                            >
                                <g id="Profile">
                                    <path
                                        d="M31.5356054,16.799798 C30.9602689,17.2244064 29.4745118,17.9646556 27.8957787,18.0940165 C26.3172004,18.2233775 22.9843024,17.1449635 21.4495047,16.5841456 C19.9147071,16.0233277 17.1958209,14.6428177 17.1958209,14.6428177 C17.1958209,14.6428177 5.1363427,17.9214338 3.77697699,18.3528907 C2.41761128,18.7841954 1.40895481,19 1.40895481,19 C1.40895481,19 -2.82322542,10.3075507 3.38233241,4.20277756 C6.75901107,0.881091875 8.53467963,0.626326832 9.87254177,0.320273964 C11.7582034,-0.111182964 12.8106405,0.0181780197 12.8106405,0.0181780197 C12.8106405,0.0181780197 16.844957,-0.154404751 20.1339197,2.39096284 C20.8232714,2.92438666 25.4839759,10.2424136 25.4839759,10.2424136 L35,12.658268 C35,12.658268 32.7634744,15.8938145 31.5356054,16.799798 Z"
                                        id="Stroke-1"
                                        stroke-width="1.5"
                                    ></path>
                                    <path
                                        d="M17.1958209,14.6428177 L25.4839759,10.2424136"
                                        id="Stroke-3"
                                        stroke-width="1.5"
                                    ></path>
                                    <path
                                        d="M19.84375,12.5756836 C19.84375,12.5756836 17.3243915,6.95948506 15.2824693,4.65464289 C13.2405472,2.34996014 10.9822174,0.772091265 9.87254177,0.320273964"
                                        id="Stroke-4"
                                        stroke-width="1.5"
                                    ></path>
                                    <path
                                        d="M9.87254177,0.320273964 C9.87254177,0.320273964 5.77017239,2.98626204 5.14762613,8.08162815 C4.52507988,13.1769943 5.94946289,17.5900879 5.94946289,17.5900879"
                                        id="Stroke-6"
                                        stroke-width="1.5"
                                    ></path>
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </svg>
            <i>Profile</i>
        </router-link>

        <router-link :to="{ name: 'playerLessons' }">
            <svg
                width="21px"
                height="23px"
                viewBox="0 0 21 23"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
            >
                <defs></defs>
                <g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                    <g
                        id="Bottom-Nav---Profile"
                        transform="translate(-105.000000, -14.000000)"
                        stroke="#267962"
                    >
                        <g id="Bottom-Nav">
                            <g
                                id="lessons-mid-dark-green"
                                transform="translate(105.000000, 15.000000)"
                            >
                                <g id="Lessons">
                                    <rect
                                        id="Rectangle"
                                        stroke-width="1.5"
                                        x="0.75"
                                        y="2.75"
                                        width="19.5"
                                        height="18.5"
                                        rx="2"
                                    ></rect>
                                    <path
                                        d="M5.5,0.428571429 L5.5,5.57142857"
                                        id="Line-2"
                                        stroke-width="1.5"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                    ></path>
                                    <path
                                        d="M15.5,0.428571429 L15.5,5.57142857"
                                        id="Line-2"
                                        stroke-width="1.5"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                    ></path>
                                    <path
                                        d="M1.5,9 L19.5,9"
                                        id="Line-3"
                                        stroke-width="1.5"
                                        stroke-linecap="square"
                                    ></path>
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </svg>

            <i>Lessons</i>
        </router-link>
        <router-link :to="{ name: 'playerGoals' }">
            <svg
                width="28px"
                height="26px"
                viewBox="0 0 28 26"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
            >
                <defs></defs>
                <g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                    <g
                        id="Bottom-Nav---Profile"
                        transform="translate(-175.000000, -11.000000)"
                        stroke="#267962"
                        stroke-width="1.5"
                    >
                        <g id="Bottom-Nav">
                            <g
                                id="goals-mid-dark-green"
                                transform="translate(175.000000, 11.000000)"
                            >
                                <path
                                    d="M21.4692474,24.280537 L21.3960718,16.4031294 L26.0854961,10.0731843 L18.5710238,7.70852552 L14,1.2925574 L9.42897623,7.70852552 L1.91450391,10.0731843 L6.60392817,16.4031294 L6.53075265,24.280537 L14,21.7766901 L21.4692474,24.280537 Z"
                                    id="Goals"
                                ></path>
                            </g>
                        </g>
                    </g>
                </g>
            </svg>

            <i>Goals</i>
        </router-link>
        <router-link :to="{ name: 'playerOffers' }">
            <svg
                width="36px"
                height="27px"
                viewBox="0 0 36 27"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
            >
                <defs></defs>
                <g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                    <g
                        id="Bottom-Nav---Profile"
                        transform="translate(-241.000000, -12.000000)"
                        stroke="#267962"
                        stroke-width="1.5"
                    >
                        <g id="Bottom-Nav">
                            <g
                                id="offers-mid-dark-green"
                                transform="translate(260.500000, 25.500000) rotate(-23.000000) translate(-260.500000, -25.500000) translate(242.000000, 19.000000)"
                            >
                                <path
                                    d="M18.032487,0.75 L0.75,0.75 L0.75,12.25 L18.032487,12.25 L27.1118891,6.5 L18.032487,0.75 Z"
                                    id="Combined-Shape"
                                ></path>
                                <path
                                    d="M23.3818359,6.5 C26.226237,2.16666667 29.5838216,2.51118629e-12 33.4545898,2.51088039e-12 C39.2607422,2.51088039e-12 36.1450195,5.98046875 30.7924805,8.01171875 C27.2241211,9.36588542 25.0296224,9.65576172 24.2089844,8.88134766"
                                    id="Path-3"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                ></path>
                            </g>
                        </g>
                    </g>
                </g>
            </svg>

            <i>Offers</i>
        </router-link>

        <router-link :to="{ name: 'playerMessages' }">
            <svg
                width="26px"
                height="23px"
                viewBox="0 0 26 23"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
            >
                <defs></defs>
                <g
                    id="Symbols"
                    stroke="none"
                    stroke-width="1"
                    fill="none"
                    fill-rule="evenodd"
                    stroke-linejoin="round"
                >
                    <g
                        id="Bottom-Nav---Profile"
                        transform="translate(-321.000000, -15.000000)"
                        stroke="#267962"
                        stroke-width="1.5"
                    >
                        <g id="Bottom-Nav">
                            <g
                                id="messages-mid-dark-green"
                                transform="translate(322.000000, 16.000000)"
                            >
                                <path
                                    d="M19.0735251,16.2709435 L21.0996094,21 L14.4760504,17.808196 C13.6770515,17.9339026 12.8488177,18 12,18 C5.372583,18 0,13.9705627 0,9 C0,4.02943725 5.372583,0 12,0 C18.627417,0 24,4.02943725 24,9 C24,11.9868469 22.0600169,14.6338633 19.0735251,16.2709435 Z"
                                    id="Messages"
                                ></path>
                            </g>
                        </g>
                    </g>
                </g>
            </svg>
            <span class="msgCounter" v-if="msgCounter > 0">{{ msgCounter }}</span>
            <i>Messages</i>
        </router-link>
    </nav>
</template>

<script>
export default {
    name: "player-navigation",
    computed: {
        msgCounter() {
            return this.$store.state.unreadMsgCount;
        },
    },
};
</script>

<style lang="scss" scoped>
.msgCounter {
    display: block;
    position: absolute;
    background: #267962;
    width: 20px;
    height: 20px;
    border-radius: 100%;
    top: 14px;
    font-size: 12px;
    left: 14px;
    color: white;
    line-height: 20px;
    text-align: center;
}
.router-link-active {
    .msgCounter {
        background: white;
        color: #267962;
    }
}
</style>
